import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Loader2 } from "lucide-react";

export const CancelApptDialog = ({ appt, patientId, onClose, onDone }) => {
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { setNote(""); }, [appt]);

  const confirm = async () => {
    setBusy(true);
    try {
      await api.post("/admin/cancel-appointment", { appointment_id: appt.appt_id, cliniko_id: patientId, from_label: appt.label, note });
      toast.success("Appointment cancelled in Cliniko");
      onDone();
    } catch (e) { toast.error(e.response?.data?.detail || "Cancel failed — nothing was changed"); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open={!!appt} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md bg-white" data-testid="cancel-dialog">
        <DialogHeader>
          <DialogTitle>Cancel appointment?</DialogTitle>
          <DialogDescription data-testid="cancel-appt-label">{appt?.label}</DialogDescription>
        </DialogHeader>
        <Textarea value={note} onChange={(e) => setNote(e.target.value)} maxLength={500} placeholder="Reason (optional) — saved to Cliniko" data-testid="cancel-reason" />
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={onClose} data-testid="cancel-keep-btn">Keep appointment</Button>
          <Button onClick={confirm} disabled={busy} className="bg-red-600 hover:bg-red-700" data-testid="cancel-confirm-btn">
            {busy && <Loader2 className="mr-1 h-4 w-4 animate-spin" />} Cancel appointment
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
